import React from "react";

export default function DetailModal({ data }) {
  return (
    <div
      class="modal fade"
      id="detailApiModal"
      tabindex="-1"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header text-center">
            <h1 class="modal-title fs-5" id="exampleModalLabel">
              CHI TIẾT API
            </h1>
          </div>
          <div className="modal-body">
            <div className="p-4 rounded border border-secondary">
              <pre
                className="m-0"
                style={{ fontSize: "14px", height: "70vh", overflowY: "auto" }}
              >
                {JSON.stringify(data, null, 2)}
              </pre>
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              data-dismiss="modal"
            >
              Đóng
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
